import { jsx as _jsx } from "react/jsx-runtime";
import { ProductStub } from '../ProductStub';
/** Uptime Reports — later-wave target (mirrors the SSL page). */
export function ReportsPage() {
    return (_jsx(ProductStub, { title: "Reports", blurb: "Uptime % by monitor and group, incident history, response-time trends, and exportable (Chaosology-branded) SLA reports. Ships after the Wave-1 core pages are solid." }));
}
